import logo from './logo.svg';
import './App.css';
// import Chatbot from 'react-chatbot-kit';
import 'react-chatbot-kit/build/main.css';
import ChatBotView from './ChatBotView';

function App() {
  return (
    <div className="App">
      {/* <header className="App-header"> */}
        {/* <img src={logo} className="App-logo" alt="logo" /> */}
        {/* <div>test</div> */}
        <ChatBotView/>
      {/* </header> */}
    </div>
  );
}

export default App;
